import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import MMV from '@/components/fakeDoor/components/mmv';
import MobileDrawer from '@/components/common/mobileDrawer';
import {
    fetchBrandServicePricing,
    fetchPackagePricing,
} from '@/components/fakeDoor/api';
import ErrorIcon from '@/assets/Icons/error-caution.svg';
import { imageLoader } from '@/utils/imageLoader';
import { formatCurrency } from '@/utils/formatters';
import { useRouter } from 'next/router';
import { MODEL_MAPPING } from './config';
import { ASSET_FALLBACK_IMAGE, CAR_MAKES } from '@/constants/common';
import { getVehicleImageUrl } from '@/utils';

const Pricing = ({
    garageId,
    servicePricingData,
    packagePricingData,
    imageUrl,
    makeName,
    modelName,
}: {
    garageId: any;
    servicePricingData: any;
    packagePricingData: any;
    imageUrl: string;
    makeName: string;
    modelName: string;
}) => {
    const [showText, setShowText] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [pricingData, setPricingData] = useState(servicePricingData);
    const [periodicPricingData, setPeriodicPricingData] =
        useState(packagePricingData);

    const [modalData, setModalData] = useState({
        makeName: makeName,
        modelName: modelName,
    });
    const [imageData, setImageData] = useState(imageUrl);

    const slugify = (str: string) => str.toLowerCase().replace(/ /g, '-');

    const seoClick = async (brandData: any) => {
        const data = await fetchBrandServicePricing(
            brandData?.model_id as number,
            brandData?.fuel_type as string,
            garageId as string
        );
        const pricingApiData = await fetchPackagePricing(
            brandData?.model_id as number,
            brandData?.fuel_type as string,
            garageId as string
        );
        const imageURL: string = getVehicleImageUrl(
            slugify(brandData.make),
            slugify(brandData.model)
        );
        setImageData(imageURL);
        setPricingData(data?.service_pricing);
        setPeriodicPricingData(pricingApiData?.package_pricing);
        setShowModal(false);
        setModalData({ makeName: brandData.make, modelName: brandData.model });
    };

    return (
        <>
            <PricingWrapper>
                <PricingHeadingWrapper>
                    <PricingHeading>Car services & Price list</PricingHeading>
                    <PricingHeadingSubText>
                        See how ACKO Drive Service Centre saves you more
                        compared to traditional dealership.
                    </PricingHeadingSubText>
                </PricingHeadingWrapper>
                <PricingTableHeading>
                    Choose your car to compare prices
                </PricingTableHeading>
                <PricingContainer>
                    <HeaderContainer>
                        <Header>
                            <CarDataContainer>
                                <CarData>
                                    <Image
                                        loader={imageLoader}
                                        src={imageData}
                                        onError={() =>
                                            setImageData(ASSET_FALLBACK_IMAGE)
                                        }
                                        width={90}
                                        height={50}
                                        alt={
                                            modalData.makeName +
                                            ' ' +
                                            modalData.modelName +
                                            ' Car-Image'
                                        }
                                        objectFit="cover"
                                    />
                                    <CarTitle>
                                        {modalData.makeName +
                                            ' ' +
                                            modalData.modelName}
                                    </CarTitle>
                                </CarData>
                                <Image
                                    src={resolvePath(
                                        '/images/seo/Edit_pencil_change.svg'
                                    )}
                                    width={18}
                                    height={18}
                                    alt="Car-Image-pencil"
                                    onClick={() => setShowModal(!showModal)}
                                />
                            </CarDataContainer>
                        </Header>
                        <SelectText>
                            Select your vehicle to view the relevant pricing
                        </SelectText>
                    </HeaderContainer>
                    {/* <DiscountBadge>20% OFF</DiscountBadge> */}
                    {pricingData?.length > 0 ||
                    periodicPricingData?.length > 0 ? (
                        <PricingTable>
                            <Table>
                                <TableHead>
                                    <TableHead1>
                                        <TableHead1Text>
                                            Packages
                                        </TableHead1Text>
                                    </TableHead1>
                                    <TableHead2>
                                        <TableHead2Text>
                                            ACKO Drive Pricing
                                        </TableHead2Text>
                                    </TableHead2>
                                    <TableHead3>
                                        <TableHead3Text>
                                            Dealership pricing
                                        </TableHead3Text>
                                    </TableHead3>
                                </TableHead>

                                <TableBody>
                                    {periodicPricingData?.map((pkg: any) => (
                                        <BodyContainer>
                                            <TableBody1>
                                                <TableBody1Text>
                                                    {(
                                                        pkg?.name
                                                            ?.replace(/_/g, ' ')
                                                            .toLowerCase() +
                                                        ' car service'
                                                    ).replace(/^\w/, (c) =>
                                                        c.toUpperCase()
                                                    )}
                                                </TableBody1Text>
                                            </TableBody1>
                                            <TableBody2>
                                                <TableBody2Text>
                                                    {formatCurrency(
                                                        pkg.offer_price
                                                    )}
                                                </TableBody2Text>
                                            </TableBody2>
                                            <TableBody3>
                                                <TableBody3Text>
                                                    {formatCurrency(
                                                        pkg.other_garage_amount
                                                    )}
                                                </TableBody3Text>
                                            </TableBody3>
                                        </BodyContainer>
                                    ))}
                                    {pricingData?.map((pkg: any) => (
                                        <BodyContainer>
                                            <TableBody1>
                                                <TableBody1Text>
                                                    {pkg?.name
                                                        ?.replace(/_/g, ' ')
                                                        .toLowerCase()
                                                        .replace(
                                                            /^\w/,
                                                            (c: any) =>
                                                                c.toUpperCase()
                                                        )}
                                                </TableBody1Text>
                                            </TableBody1>
                                            <TableBody2>
                                                <TableBody2Text>
                                                    {formatCurrency(
                                                        pkg.offer_price
                                                    )}
                                                </TableBody2Text>
                                            </TableBody2>
                                            <TableBody3>
                                                <TableBody3Text>
                                                    {formatCurrency(
                                                        pkg.other_garage_amount
                                                    )}
                                                </TableBody3Text>
                                            </TableBody3>
                                        </BodyContainer>
                                    ))}
                                </TableBody>
                            </Table>
                            <CheckContainer
                                onClick={() => {
                                    setShowText(!showText);
                                }}
                            >
                                <CheckHeadTextContainer>
                                    <CheckHeadText>
                                        Check how we offer quality service at
                                        lower prices
                                    </CheckHeadText>
                                    <Image
                                        src={resolvePath(
                                            '/images/seo/Chevron-down.svg'
                                        )}
                                        width={16}
                                        height={16}
                                        alt="Chevron-down"
                                        style={
                                            showText
                                                ? {
                                                      transform:
                                                          'rotate(180deg)',
                                                  }
                                                : {}
                                        }
                                    />
                                </CheckHeadTextContainer>
                                {showText && (
                                    <CheckHeadBottomTextContainer>
                                        Brand-authorised service centres often
                                        charge higher fees for labour and parts.
                                        At ACKO Drive, we believe in passing
                                        those savings directly to you, building
                                        trust through transparent pricing
                                    </CheckHeadBottomTextContainer>
                                )}
                            </CheckContainer>
                        </PricingTable>
                    ) : (
                        <ErrorContainer>
                            <ErrorMessage>
                                <ErrorIcon />
                                <div>
                                    We’re unable to provide a price for your
                                    vehicle right now
                                </div>
                                <span>
                                    No worries, book a slot and our Service
                                    Advisor will get back to you with a
                                    personalised quote
                                </span>
                            </ErrorMessage>
                        </ErrorContainer>
                    )}
                </PricingContainer>
            </PricingWrapper>
            {showModal && (
                <MobileDrawer
                    show={showModal}
                    onClose={() => setShowModal(false)}
                >
                    <MMV
                        isSeo={true}
                        pricingGarageId={garageId}
                        seoClick={seoClick}
                    />
                </MobileDrawer>
            )}
        </>
    );
};

export default Pricing;

const ErrorContainer = styled.div`
    margin: 20px 0 0;
    position: relative;
`;

const ErrorMessage = styled.div`
    top: -100px;
    border-radius: 16px;
    border: 1px solid var(--Red-R100, #f3c0be);
    background: var(--Surface-White, #fff);
    box-shadow: 0px 2px 32px 0px rgba(18, 18, 18, 0.08);
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    z-index: 1;
    gap: 8px;
    & > div {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
    & > span {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
    }
`;

const CheckHeadBottomTextContainer = styled.div`
    color: #4b4b4b;
    text-align: center;
    font-family: Euclid Circular B;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

const CheckHeadText = styled.div`
    color: #1b73e8;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    width: 100%;
`;

const CheckHeadTextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
`;

const CheckContainer = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background: #f8f7fc;
    border-radius: 12px;
    width: calc(100% - 32px);
`;

const BodyContainer = styled.div`
    display: flex;
    width: 100%;
`;

const TableBody3 = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    min-width: 101px;
    max-width: 101px;
`;

const TableBody2 = styled.div`
    background: #fbe9f6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 101px;
    max-width: 101px;
`;

const TableBody1Text = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

const TableBody2Text = styled.div`
    color: #040222;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

const TableBody3Text = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const TableBody1 = styled.div`
    display: flex;
    padding: 20px 16px 24px 16px;
    flex-direction: column;
    align-items: flex-start;
    background: #fff;
    width: 28%;
`;

const TableBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

const TableHead1 = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    width: 28%;
`;

const TableHead2 = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    background: #fbe9f6;
    min-width: 69px;
    max-width: 69px;
`;

const TableHead3 = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    min-width: 69px;
    max-width: 69px;
`;

const TableHead1Text = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

const TableHead2Text = styled.div`
    text-align: center;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    background: linear-gradient(91deg, #2dab74 -0.71%, #535dbf 102.54%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const TableHead3Text = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

const TableHead = styled.div`
    display: flex;
    align-items: center;
    align-self: stretch;
    background: #f8f7fc;
`;

const PricingTable = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 12px;
    background: #f8f7fc;
    margin-top: 20px;
`;

const CarDataContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    align-self: stretch;
`;

const CarData = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1 0 0;
`;

const PricingTableHeading = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    align-self: stretch;
`;

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
`;

const PricingWrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    background: #fff;
`;

const PricingHeadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

const PricingHeading = styled.h2`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    align-self: stretch;
    margin: 0;
`;

const PricingHeadingSubText = styled.div`
    color: #4b4b4b;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    align-self: stretch;
`;

const PricingContainer = styled.div`
    width: 100%;
`;

const Header = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-radius: 8px;
    background: linear-gradient(93deg, #f3f5fd 37.99%, #cef0ff 110.32%);
`;

const SelectText = styled.div`
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    background: #fff7e5;
    color: #d16900;
    font-family: 'Euclid Circular B';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

const CarTitle = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const Table = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 12px;
    border: 1px solid #e8e8e8;
    background: #fff;
    overflow: hidden;
    width: 100%;
`;

const DiscountBadge = styled.span``;
